import { Stack } from '@mui/material';
import React from 'react';

import { usePageContext } from '@contexts/page-context';

import { useAdminGetPolicy } from 'generated/admin.generated';

import MetadataEditor from './MetadataEditor';
import PermissionList from './PermissionList';

interface PolicyDrilldownProps {
  policy_id: string;
}

const PolicyDrilldown = ({
  policy_id,
}: React.PropsWithChildren<PolicyDrilldownProps>) => {
  const { data: policyData, loading } = useAdminGetPolicy({
    variables: { input: { policy_id } },
  });
  const { setTitle } = usePageContext();
  const policy = policyData?.getPolicy;

  React.useEffect(() => {
    if (policy?.policy_name) {
      setTitle(policy.policy_name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [policy?.policy_name]);

  return (
    <Stack spacing={1}>
      <MetadataEditor policy={policy} />
      <PermissionList policy={policy} loading={loading} />
    </Stack>
  );
};

export default PolicyDrilldown;
